export default class calendarioService{

	constructor($http, baseUrl){
		this.http    = $http;
		this.baseUrl = baseUrl;

		this.routes = {
			"calendario": '/api/calendario',
			"byottid": '/api/calendario/byTecId/:id',
			"list": "/api/calendario/list"
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.list;
		let config = {};
		if (filter !== undefined) {
			if (typeof filter == 'string') {
				config.params = {
					string: filter
				}
			}else{
				config.params = filter;
			}
		}

		return this.http.get(url, config);
	}

	save(data){
		let url = this.baseUrl + this.routes.calendario;
		return this.http.post(url, data);
	}

	byTecId(id) {
		let idRoute = this.routes.byottid.replace(':id', id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	getList(filter){
		let url = this.baseUrl + this.routes.calendario;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/calendarioService.js